import { Flex, Grid, Icon } from "@chakra-ui/react";
import React from "react";
import { FaDollarSign, FaShoppingCart, FaUser } from "react-icons/fa";
import Card from "../../../../../components/card/Card";
import { IDashboard } from "../../types";
import CardContent from "./card-content";
import { useTranslation } from "react-i18next";

interface Props {
  data: IDashboard;
}

const DataBox: React.FC<Props> = ({ data }) => {
    const {t}= useTranslation()
  function calculatePercentageChange(
    current: number,
    previous: number
  ): string {
    // If both current and previous values are zero, return an empty string
    if (current === 0 && previous === 0) {
      return "";
    }

    const difference = current - previous;
    const total = current + previous;
    // If the difference is zero, return an empty string
    if (difference === 0) {
      return "";
    }
    const percentageChange = (current * 100) / total;

    const sign = difference > 0 ? "+" : "-";
    const formattedPercentage = `${sign}${Math.abs(percentageChange).toFixed(
      0
    )}%`;
    console.log(formattedPercentage, percentageChange, "formattedPercentage");

    return formattedPercentage;
  }
  return (
    <Flex>
      <Card>
        <Grid
          pt={{ base: "30px" }}
          mb="20px"
          gridTemplateColumns={{
            base: "repeat(1, 1fr)",
            md: "repeat(2, 1fr)",
            lg: "repeat(3, 1fr)",
            xl: "repeat(3, 1fr)",
            "2xl": "repeat(4, 1fr)",
          }}
          gap={{ base: "20px", xl: "20px" }}
          display="grid"
        >
          <CardContent
            icon={
             <Icon as={FaDollarSign} boxSize={5} color="#fff" />
            }
            headLine={t("dashboard.totalIncome")}
            amount={data?.totalPayment?.toFixed()?.toString()}
            isDown={false}
            percentValue={calculatePercentageChange(
              data?.totalPayment,
              data?.previousTotalPayment
            )}
            isAmount={true}
          />
          <CardContent
            icon={
             <Icon as={FaShoppingCart} boxSize={5} color="#fff" />
            }
            headLine={t("dashboard.totalOrder")}
            amount={data?.orderCount?.toFixed()?.toString()}
            isDown={true}
            percentValue={calculatePercentageChange(
              data?.orderCount,
              data?.previousOrderCount
            )}
          />
          <CardContent
            icon={
              <Icon as={FaUser} boxSize={5} color="#fff"/>
            }
            headLine={t("dashboard.totalUser")}
            amount={data?.userCount?.toFixed()?.toString()}
            isDown={false}
            percentValue={calculatePercentageChange(
              data?.userCount,
              data?.previousUserCount
            )}
          />
        </Grid>
      </Card>
    </Flex>
  );
};

export default DataBox;
